import { gql } from '@apollo/client';
import { CourseLineData } from './course-line';

export const GET_COURSE_LINE_ITEMS = gql`
  query GetCourseLines($query: QueryCourseLineInput) {
    CourseLine_getList(query: $query) {
      data {
        ${CourseLineData}
      }
      count
      page
      pages
      limit
    }
  }
`;

export const CREATE_COURSE_LINE = gql`
  mutation CreateCourseLine($payload: CreateCourseLineInput!) {
    CourseLine_create(createCourseLineInput: $payload) {
      ${CourseLineData}
    }
  }
`;

export const UPDATE_COURSE_LINE = gql`
  mutation UpdateCourseLine($payload: UpdateCourseLineInput!) {
    CourseLine_update(updateCourseLineInput: $payload) {
      ${CourseLineData}
    }
  }
`;

export const DETAIL_COURSE_LINE = gql`
  query GetCourseLineById($id: String!) {
    CourseLine_getById(id: $id) {
      ${CourseLineData}
    }
  }
`;

export * from './course-line';
